import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

function escapeHtml(s: string): string {
  return s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

@Pipe({
  name: 'formatMessage',
  standalone: true,
})
export class FormatMessagePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string): SafeHtml {
    if (!value) return '';

    const lines = value.split('\n');
    const parts: string[] = [];

    for (const line of lines) {
      const heading = line.match(/^##\s+(.+)$/);
      if (heading) {
        parts.push(
          `<h3 class="ai-navigator-section">${escapeHtml(heading[1].trim())}</h3>`,
        );
        continue;
      }
      let segment = escapeHtml(line);
      segment = segment.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
      parts.push(segment);
    }

    const formatted = parts.join('<br>');
    return this.sanitizer.bypassSecurityTrustHtml(formatted);
  }
}
